import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1fa1b744"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "recoverpwd__form" }
const _hoisted_2 = {
  key: 0,
  class: "recoverpwd__form__col recover__form__msg"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "E-mail:", -1))
const _hoisted_4 = { class: "recoverpwd__form__button" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = {
  key: 1,
  class: "recover__form__msg recoverpwd__form__button",
  style: {"align-items":"center","justify-content":"space-evenly"}
}
const _hoisted_7 = {
  key: 2,
  class: "recover__form__msg recoverpwd__form__button",
  style: {"align-items":"center","justify-content":"space-evenly"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FieldInput = _resolveComponent("FieldInput")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", null, _toDisplayString(_ctx.$t('recoverpwd.title')), 1),
    (_ctx.recoveryUserPwdStatus === _ctx.RecoverUserPwdRequestStatus.WithoutStatus)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('recoverpwd.title2')), 1),
          _createElementVNode("div", null, [
            _hoisted_3,
            _createVNode(_component_FieldInput, {
              name: "username",
              type: "email",
              modelValue: _ctx.email,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.Cancel && _ctx.Cancel(...args))),
              value: "Cancel"
            }, _toDisplayString(_ctx.$t('menu.cancel')), 1),
            _createElementVNode("button", {
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.RecoverUserPwd && _ctx.RecoverUserPwd(...args))),
              disabled: !_ctx.isValid,
              value: "Go"
            }, _toDisplayString(_ctx.$t('menu.send')), 9, _hoisted_5)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.recoveryUserPwdStatus === _ctx.RecoverUserPwdRequestStatus.OK)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('recoverpwd.postmsg')), 1),
          _createElementVNode("button", {
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.GoLogin && _ctx.GoLogin(...args)))
          }, "Login")
        ]))
      : _createCommentVNode("", true),
    (_ctx.recoveryUserPwdStatus === _ctx.RecoverUserPwdRequestStatus.Error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('recoverpwd.errormsg')), 1),
          _createElementVNode("button", {
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.Retry && _ctx.Retry(...args)))
          }, _toDisplayString(_ctx.$t('menu.retry')), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}